import { Badge } from "@babackapp/ui/components/badge";
import { Checkbox } from "@babackapp/ui/components/checkbox";
import { Link } from "react-router-dom";
import {
  BACKFILL_STATUSES,
  type BackfillStatus,
  type ShopBackfillSummary,
} from "./pii-backfill-summary";

export type BackfillShop = {
  id: string;
  name: string;
  totalOrders: number;
  isTestShop: boolean;
};

const STATUS_STYLES: Record<BackfillStatus, string> = {
  never: "bg-muted text-muted-foreground",
  running: "bg-violet-100 text-violet-800",
  paused: "bg-amber-100 text-amber-800",
  partial: "bg-orange-100 text-orange-800",
  done: "bg-green-100 text-green-800",
};

export function PiiBackfillShopRow({
  shop,
  summary,
  isSelected,
  onToggle,
}: {
  shop: BackfillShop;
  summary: ShopBackfillSummary;
  isSelected: boolean;
  onToggle: () => void;
}) {
  return (
    <tr className="border-b last:border-0 hover:bg-muted/30">
      <td className="px-3 py-2 w-8">
        <Checkbox checked={isSelected} onCheckedChange={onToggle} />
      </td>
      <td className="px-3 py-2">
        <Link
          to={`/shops/${shop.id}/pii-lookup`}
          className="font-medium hover:underline"
        >
          {shop.name}
        </Link>
        {shop.isTestShop && (
          <span className="ml-2 text-xs text-muted-foreground">test</span>
        )}
      </td>
      <td className="px-3 py-2 text-right tabular-nums">
        {shop.totalOrders.toLocaleString("fr-FR")}
      </td>
      <td className="px-3 py-2">
        <Badge variant="outline" className={STATUS_STYLES[summary.status]}>
          {BACKFILL_STATUSES[summary.status]}
        </Badge>
        {summary.ordersSince !== null && (
          <span className="ml-2 text-xs text-muted-foreground">
            commandes depuis le{" "}
            {new Date(summary.ordersSince).toLocaleDateString("fr-FR")}
          </span>
        )}
      </td>
      <td className="px-3 py-2 w-48">
        {summary.status !== "never" && (
          <div className="flex items-center gap-2">
            <div className="h-2 flex-1 rounded bg-muted">
              <div
                className="h-2 rounded bg-emerald-500"
                style={{ width: `${summary.percent}%` }}
              />
            </div>
            <span className="text-xs tabular-nums text-muted-foreground">
              {summary.percent} %
            </span>
          </div>
        )}
      </td>
    </tr>
  );
}
